export const BLUE = '#0085CA'
export const PURPLE = '#5f249f'
export const RED = '#f54055'
export const MINT = '#64ccc9'
export const PINK = '#db3f8c'
export const YELLOW = '#ffb81c'
export const DARK_BLUE = '#0085ca'

export const GREY = '#d8d8d8'
export const LIGHT_GREY = '#f6f6f7'
export const DARK_GREY = '#262626'

export const WHITE = '#FFFFFF'
export const BLACK = '#000000'

export const SHADOW = 'rgba(0,0,0,0.2)'
export const BORDER = 'solid 1px #CCCCCC'

export const PROGRESS = '#3C77C3'
export const REVIEW = '#E9B342'
export const COMPLETE = '#45C754'
